
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as map_45embeddedgcb86iWvKdPT9DrlahkNKl0vVEwWvkZx5ewk6bMx_ewMeta } from "/var/www/mysite/app/pages/map-embedded.vue?macro=true";
import { default as _91id_937VTtpaSMMRTRAjgxFY0o_vK_Uxq7WIkjfSUGpuKeMgEMeta } from "/var/www/mysite/app/pages/feedback-list/[id].vue?macro=true";
import { default as _91slug_93mFr26Gn8FKRo7M_agX0_8iefq0DSv81V1rQ0KrfUt_UMeta } from "/var/www/mysite/app/pages/pool/drawer/[slug].vue?macro=true";
import { default as _91networkSlug_93d7UocK_ggdWyOvfAzuSXGB_wmm3df0GUWtHr5rfDgPUMeta } from "/var/www/mysite/app/pages/networks/[networkSlug].vue?macro=true";
import { default as _91_91pageIndex_93_93y1TNdfFtKwqbrEqA1d_kZQQXyxW7ibdKxJ1keGGbFesMeta } from "/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue?macro=true";
export default [
  {
    name: "map-embedded___en-gb",
    path: "/en-gb/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___fr-fr",
    path: "/fr-fr/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___nl-nl",
    path: "/nl-nl/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___it-it",
    path: "/it-it/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___es-es",
    path: "/es-es/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___de-de",
    path: "/de-de/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___pt-pt",
    path: "/pt-pt/map-embedded",
    component: () => import("/var/www/mysite/app/pages/map-embedded.vue")
  },
  {
    name: "feedback-list-id___en-gb",
    path: "/en-gb/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___fr-fr",
    path: "/fr-fr/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___nl-nl",
    path: "/nl-nl/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___it-it",
    path: "/it-it/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___es-es",
    path: "/es-es/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___de-de",
    path: "/de-de/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___pt-pt",
    path: "/pt-pt/feedback-list/:id()",
    component: () => import("/var/www/mysite/app/pages/feedback-list/[id].vue")
  },
  {
    name: "pool-drawer-slug___en-gb",
    path: "/en-gb/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___fr-fr",
    path: "/fr-fr/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___nl-nl",
    path: "/nl-nl/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___it-it",
    path: "/it-it/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___es-es",
    path: "/es-es/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___de-de",
    path: "/de-de/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___pt-pt",
    path: "/pt-pt/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/app/pages/pool/drawer/[slug].vue")
  },
  {
    name: "networks-networkSlug___en-gb",
    path: "/en-gb/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___fr-fr",
    path: "/fr-fr/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___nl-nl",
    path: "/nl-nl/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___it-it",
    path: "/it-it/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___es-es",
    path: "/es-es/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___de-de",
    path: "/de-de/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___pt-pt",
    path: "/pt-pt/networks/:networkSlug()",
    component: () => import("/var/www/mysite/app/pages/networks/[networkSlug].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___en-gb",
    path: "/en-gb/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___fr-fr",
    path: "/fr-fr/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___nl-nl",
    path: "/nl-nl/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___it-it",
    path: "/it-it/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___es-es",
    path: "/es-es/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___de-de",
    path: "/de-de/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___pt-pt",
    path: "/pt-pt/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/app/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  }
]